import { Route } from "react-router";

interface RouteProperties {
	path: string,
	children?: any,
	component?: any,
	exact?: boolean,
	securityContext?: string,
	securityContextPermission?: string
}

export function SALRoute(props: RouteProperties) {
	return <Route {...props} />;
}